const SkillsProgression = [
    {
        id: 1001,
        title: "Web Development",
        institute: "Apna College",
        duration: "2022-2023",
        result: "Completed",
        description: "Gained comprehensive skills in full-stack development, mastering HTML, CSS, JavaScript, React, Node.js, and database integration."
    },
    {
        id: 1002,
        title: "Data Science",
        institute: "WS Cube Tech",
        duration: "2023-2025",
        result: "Ongoing",
        description: "Focused on Python, machine learning, data analysis, and visualization techniques. Applying these skills to analyze data sets and build predictive models using libraries like Pandas, NumPy, and scikit-learn."
    },
    {
        id: 1003,
        title: "WordPress Development",
        institute: "WS Cube Tech",
        duration: "2023-2024",
        result: "Completed",
        description: "Developed expertise in building and customizing websites using WordPress, covering themes, plugins, and advanced settings."
    }
];

export default SkillsProgression;
